import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { Box } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { routes } from "../../constants/routes";
import { CartContext } from "../../context/CartContext";
import { colors } from "../../theme/colors";
import { ButtonSize, ButtonVariant } from "../utils/Button";
import NavButton from "../utils/NavButton";

const CartButton = ({
  mobile,
  setMobileNavOpen
}: {
  mobile?: boolean;
  setMobileNavOpen?: () => void;
}) => {
  const { t } = useTranslation();
  const { cart } = useContext(CartContext);
  const location = useLocation();

  const cartLabel = t("buttons.cart");
  const cartAriaLabel = cart?.length > 0 ? `${cartLabel} (${cart.length})` : cartLabel;

  return (
    <Box position="relative">
      {mobile && (
        <NavButton
          onClick={setMobileNavOpen}
          route={routes.cart}
          label={cartLabel}
          aria-label={cartAriaLabel}
          variant={ButtonVariant.secondary}
          size={ButtonSize.full}
        />
      )}

      {!mobile && (
        <NavButton
          route={routes.cart}
          startIcon={<ShoppingCartOutlinedIcon titleAccess={cartLabel} />}
          aria-label={cartAriaLabel}
          variant={ButtonVariant.accent}
          isActive={location.pathname === routes.cart}
          activeStyle={{
            color: colors.green,
            backgroundColor: "transparent",
            border: `3px solid ${colors.green}`
          }}
        />
      )}

      {cart?.length > 0 && (
        <Box
          aria-hidden="true"
          sx={(theme) => ({
            position: "absolute",
            borderRadius: "100%",
            width: theme.spacing(5),
            height: theme.spacing(5),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "0.8rem",
            fontWeight: "900",
            top: theme.spacing(-1.5),
            right: theme.spacing(-1.5),
            backgroundColor: "red",
            color: "white",
            pointerEvents: "none"
          })}>
          {cart.length}
        </Box>
      )}
    </Box>
  );
};

export default CartButton;
